import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-to-buy',
  templateUrl: './how-to-buy.component.html',
  styleUrls: ['./how-to-buy.component.css']
})
export class HowToBuyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
